module.exports = __webpack_public_path__ + "static/media/payment.7e794b60.svg";